<script>
  import {Lottie} from 'lottie-svelte'
  import {signInWithCredential} from 'firebase/auth';
  import {container, itemA, itemB, itemC} from '../components/animations.js'
  import {fade, fly} from 'svelte/transition'
  import {getAuth} from 'firebase/auth'
  import {M, Motion} from 'svelte-motion'
  import { sessionData } from '../stores';
  import {Rive, Fit, Layout, Alignment} from "@rive-app/canvas"
  import TopUp from '../components/TopUp.svelte'
  import { onMount } from 'svelte';
  import {_} from 'svelte-i18n';
  import {showStartIntercom} from '../lib.js';

  let selected = true;
  let canvas;
  let currHover = ''
  let searching = false
  let expl = false
  let _auth

  let innerWidth, innerHeight;

  const switchHover = (r) => {
    if(currHover == r){
      currHover = ''
    } else {
      currHover = r
    }
  };
</script>


<div class="overflow-hidden grid grid-cols-3 h-screen" transition:fly={{x: 80, duration: 500, opacity: 0}}>
  <div class="m-auto">
    <TopUp/>
    <button on:click={showStartIntercom($sessionData.user.uid)} class="gap-x-3 flex content-center flex-row w-12 font-brown">
      <img src="withdraw.svg" alt="withdraw.svg">
      <h1 class="w-40 text-xl text-left whitespace-nowrap">{$_('gameplay.withdraw')}</h1>
    </button>
  </div>
</div>

<style>
</style>
